import { render, staticRenderFns } from "./VerifyOtpCode.vue?vue&type=template&id=7b869d84&scoped=true"
import script from "./VerifyOtpCode.vue?vue&type=script&lang=js"
export * from "./VerifyOtpCode.vue?vue&type=script&lang=js"
import style0 from "./VerifyOtpCode.vue?vue&type=style&index=0&id=7b869d84&prod&lang=css"
import style1 from "./VerifyOtpCode.vue?vue&type=style&index=1&id=7b869d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b869d84",
  null
  
)

export default component.exports